import { useCallback, useState } from 'react';

import { BtnGroup, BtnToolbar, ButtonAction, HookFormResolver, PageTitle } from '@dec/shared';
import { Text } from '@dec/shared';
import { Button } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { Col, Row } from 'react-bootstrap';
import { CardChecklist } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import GridApplication from '@/app/components/grid/gridApplication';

import { type CatalogValue } from '../../models/Catalog';
import { catalogService } from '../../services/catalog.service';

import { getColumns } from './columns';

interface CatalogFilter {
  name?: string;
  description?: string;
}

interface CatalogValueListProps {
  id: string;
  handleEdit: (row: CatalogValue) => void;
  handleCreate: () => void;
}

export const CatalogValueList = ({ id, handleEdit, handleCreate }: CatalogValueListProps) => {
  const columns: Array<ColDef> = getColumns(handleEdit);

  // columnas de la grilla
  const [search, setSearch] = useState<CatalogFilter>({});

  // ejecucióin de la busqueda con nuevos filtros
  // usecallback se usa para que no se cree una nueva función por cada render
  const handleSearch = useCallback((values: CatalogFilter) => {
    console.log({ values: values });
    // en este caso coinciden los valores de busqueda y los intresados por el form
    // caso contrario habria que transformarlos y definir interfaces particulares para c/uno
    setSearch(values);
  }, []);

  const navigate = useNavigate();
  const handleReturn = () => {
    navigate(`/configuration/catalog/list`);
  };

  const url: string = catalogService.urlValueList(id);

  return (
    <>
      <PageTitle title={t('catalog.valueList')} icon={CardChecklist} subtitle={id} />

      <HookFormResolver onSubmit={handleSearch} initialValues={{ name: null }}>
        {() => {
          return (
            <>
              <Row>
                <Col>
                  <Text label={t('catalog.values.name')} name="name" />
                </Col>
              </Row>

              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.return}
                    variant={'secondary'}
                    onClick={() => handleReturn()}
                  />
                </BtnGroup>
                <BtnGroup>
                  {/* el boton de nuevo abre un nuevo une nueva ventana de edición para agregar
                  un nuevo catálogo */}
                  <Button action={ButtonAction.new} onClick={handleCreate} />
                  <Button action={ButtonAction.find} type={'submit'} variant={'primary'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </HookFormResolver>
      <Row className="mt-5">
        <Col>
          <GridApplication columnDefs={columns} url={url} search={search} />
        </Col>
      </Row>
    </>
  );
};
